import {ReportService} from '../../api.service';
import router from '../../router.js';

export default {
    namespaced: true,
    state: {
        items: [],
        report: {
            id: 0,
            title: '',
            secretWord: ''
        },
        elements: [],
        pagination: {
            currentPage: 1,
            limit: 50,
            totalRows: 0
        },
        edit: true,
        status: 'public',
        organizationOwner: '',
        parameters: [],
        parametersChart: [],
        routeParameters: [],
        mergedParameters: [],
    },
    getters: {
        getParametersChart: state => state.parametersChart
    },
    actions: {
        fetch: function ({commit, state, rootState}) {
            if (rootState.organizationSelected === '-1') {
                return false;
            }

            let params = {
                id: rootState.organizationSelected,
                limit: state.pagination.limit,
                page: state.pagination.currentPage,
                resource: 'organization',
                list: 'report'
            };
            return ReportService.getByCriteria(params)
                .then(res => {
                    commit('SET_REPORTS', res.data.data.reports.data);
                    commit('SET_PAGINATION', res.data.data.reports);
                }).catch((error) => {
                    return error;
                });
        },
        fetchReport: function ({commit}, payload) {
            return ReportService.getReport(payload)
                .then(res => {
                    commit('SET_REPORT_ELEMENTS', res.data.data.report.report);
                    commit('SET_REPORT_STATUS', res.data.data.report.status);
                    commit('SET_REPORT_TITLE', res.data.data.report.title);
                    commit('SET_REPORT_ORGANIZATION', res.data.data.report.organization.name);
                    commit('SET_REPORT_PARAMETERS', res.data.data.report.parameters);
                })
                .catch(error => {
                    commit('SET_EXCEPTIONS', error.response.data, {root: true});
                    commit('SET_REPORT_STATUS', error.response.data.message);
                    commit('SET_REPORT_TITLE', '');
                });
        },
        fetchSharedReport: function ({commit, dispatch, state}, payload) {
            return dispatch('fetchReport', payload).then(() => {
                return new Promise(resolve => {
                    if (typeof payload.routeQuery !== "undefined" && Boolean(Object.keys(payload.routeQuery)[0])) {
                        dispatch('getParametersAsArray', payload.routeQuery).then(() => {
                            dispatch('mergeArrays', {
                                a: state.parameters,
                                b: state.routeParameters,
                                key: 'name'
                            }).then(() => {
                                commit('SET_REPORT_PARAMETERS', state.mergedParameters);
                                commit('SET_PARAMETERS');
                                resolve();
                            })
                        })                    
                    } else {
                        resolve();
                    }
                })
            })
        },
        create: function ({commit, dispatch, state, rootState}) {
            let payload = {
                'report': state.elements,
                'organization_id': rootState.organizationSelected,
                'title': state.report.title,
                'status': state.status
            };
            return ReportService.create(payload)
                .then(res => {
                    commit('SET_REPORT_CREATED', res.data.data.report);
                    commit('SET_REPORT_TITLE', res.data.data.report.title);
                    commit('SET_REPORT_STATUS', res.data.data.report.status);
                    dispatch('setSuccess', res.data.message, {root: true});
                    router.replace({name: 'report.edit', params: {report_id: res.data.data.report.id}});
                })
                .catch(error => {
                    dispatch('setExceptions', error.response.data, {root: true})
                });
        },
        update: function ({dispatch, state, rootState}, slug) {
            let payload = {
                'id': slug,
                'report': state.elements,
                'organization_id': rootState.organizationSelected,
                'title': state.report.title,
                'status': state.status
            };
            if (state.report.secretWord) {
                payload.secret_word = state.report.secretWord;
            }
            return ReportService.update(payload.id, payload)
                .then(res => {
                    dispatch('setSuccess', res.data.message, {root: true});
                })
                .catch(error => {
                    dispatch('setExceptions', error.response.data, {root: true})
                });
        },
        delete: function ({dispatch}, payload) {
            return ReportService.destroy(payload.id)
                .then(res => {
                    dispatch('setSuccess', res.data.message, {root: true});
                    dispatch('fetch');
                })
                .catch(error => {
                    dispatch('setExceptions', error.response.data, {root: true});
                });
        },
        addText: function ({commit}) {
            let id = +new Date(),
                text = {"x": 0, "y": 0, "w": 30, "h": 4, "i": id, "type": 'text', "data": 'Double click to edit'};
            commit('SET_GRID_ELEMENT', text);

        },
        addChart: function ({commit}, payload) {
            let data = {
                    id: +new Date(),
                    width: 380,
                    height: 350,
                    idVisualization: payload.id,
                    queryId: payload.queryId
                },
                chart = {
                    "x": 0,
                    "y": 0,
                    "w": 10,
                    "h": 20,
                    "i": data.id,
                    "id": payload.id,
                    "type": 'chart',
                    "data": data
                };
            commit('SET_GRID_ELEMENT', chart);
        },
        addBigNumber: function ({commit}, payload) {
            let data = {
                    id: +new Date(),
                    idVisualization: payload.id,
                    queryId: payload.queryId
                },
                bigNumber = {
                    "x": 0,
                    "y": 0,
                    "w": 5,
                    "h": 7,
                    "i": data.id,
                    "id": payload.id,
                    "type": 'chart',
                    "data": data
                };
            commit('SET_GRID_ELEMENT', bigNumber);
        },
        getParametersAsArray: function ({commit}, parameters) {
            for (let [key, value] of Object.entries(parameters)) {
                let parameter = {
                    "name": key,
                    "default": value
                };
                commit('SET_ROUTE_PARAMETERS', parameter);
            }
        },
        mergeArrays: function ({commit}, payload) {
            payload.a.forEach(aitem => {
                let found = payload.b.find( bitem => aitem[payload.key] === bitem[payload.key]);
                if (found) {
                    aitem.default = found.default
                }
                commit('SET_MERGED_PARAMETERS', aitem);
            });
        },
        routeHasParameters: function ({commit}, routeQuery) {
            return (typeof routeQuery !== "undefined" && Boolean(Object.keys(routeQuery)[0]));
        },
        setInitialStatus: function ({commit}) {
            commit('CLEAR_REPORT_ELEMENTS');
            commit('SET_EDIT_MODE', true);
            commit('SET_REPORT_TITLE', 'Untitled Report');
            commit('SET_REPORT_ORGANIZATION', '');
            commit('SET_REPORT_STATUS', 'public');
            commit('SET_REPORT_PARAMETERS', []);
            commit('SET_PARAMETERS');
        }

    },
    mutations: {
        SET_REPORTS: (state, reports) => {
            state.items = reports;
        },
        SET_PAGINATION: (state, element) => {
            state.pagination.currentPage = element.current_page;
            state.pagination.totalRows = element.total;
        },
        SET_CURRENT_PAGE: (state, page) => {
            state.pagination.currentPage = page;
        },
        SET_REPORT_CREATED: (state, report) => {
            state.report.id = report.id;
        },
        SET_REPORT_TITLE: (state, title) => {
            state.report.title = title;
        },
        SET_PARAMETERS: (state) => {
            state.parametersChart = JSON.parse(JSON.stringify(state.parameters));
        },
        SET_REPORT_PARAMETERS: (state, params) => {
            state.parameters.splice(0, state.parameters.length);
            state.parameters = params;
        },
        SET_REPORT_ELEMENTS: (state, elements) => {
            state.elements = elements;
        },
        SET_ROUTE_PARAMETERS: (state, parameter) => {
            state.routeParameters.push(parameter);
        },
        SET_MERGED_PARAMETERS: (state, parameter) => {
            state.mergedParameters.push(parameter);
        },
        SET_GRID_ELEMENT: (state, element) => {
            state.elements.push(element);
        },
        SET_EDIT_MODE: (state, boolean) => {
            state.edit = boolean;
        },
        UPDATE_GRID_ELEMENT: (state, payload) => {
            state.elements.find(element => element.i == payload.i).data = payload.data;
        },
        CLEAR_REPORT_ELEMENTS: (state) => {
            state.elements = [];
        },
        SET_TEXT_VALUE: (state, payload) => {
            state.elements.find(element => element.i === payload.id).data = payload.text;
        },
        SET_REPORT_STATUS: (state, status) => {
            state.status = status;
        },
        SET_REPORT_ORGANIZATION: (state, organization) => {
            state.organizationOwner = organization;
        },
        SET_PAGINATION_LIMIT: (state, limit) => {
            state.pagination.limit = limit;
        }
    }
}